import { useContext } from 'react';
import { StoresContext } from '../stores/RootStore';

export default function useStores() {
  return useContext(StoresContext);
}
